import trackCommonEvent from '@/common/js/track'

export default function trackEvent ({eventId = '', eventLabel = '', attrs = {}, callback = () => {}}) {
  let isShare = this.params.share === '1' ? 1 : 0
  let sodaChannelId = `${this.params.channel_id || 'offline0'}_${isShare}_${this.landingpage}`
  attrs = {
    ...attrs,
    ...{
      sailing_channel_id: sodaChannelId,
      sailing_activity_id: this.params.activity_id,
      sailing_ext_param: this.params
    }
  }
  trackCommonEvent({
    'eventId': eventId,
    'eventLabel': eventLabel,
    'attrs': {...attrs},
    'callback': callback
  })
}
